import IMWarehouseDelete from './IMWarehouseDeleteModal';

export default IMWarehouseDelete;
